import React from "react";
import { Link } from "react-router-dom";

import { UrlProvider } from "../../../../../api/UrlProvider";
import withGlobalConfigFields from "../../../../../hocs/withGlobalConfigFields";
import { globalConfigFields } from "../../../../../redux/modules/globalConfig";
import ContentSection from "../../../common/ContentSection";
import SquaberButton from "../../../common/SquaberButton";

const PremiumOfferBox = ({ translate, locale }) => (
  <ContentSection>
    <h1>{translate("Check Squaber offer")}</h1>
    <p>{translate("Check latest offer and choose the right plan for you")}</p>
    <Link to={UrlProvider.getUrl("fe.plans.mainPage", { locale })}>
      <SquaberButton onClick={() => {}}>
        {translate("Whole Squaber offer")}
      </SquaberButton>
    </Link>
  </ContentSection>
);

export default withGlobalConfigFields([globalConfigFields.OFFER_URL])(
  PremiumOfferBox
);
